import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isSchoolAdmin } from '../../../../library/Core/SmartFunctions';

const ProfileCertifications = () => {
    const { state } = useContext(SmartContext);
    const navigate = useNavigate();

    const [actionBtnStatus, setActionBtnStatus] = useState<Record<string, boolean>>({});

    const model = { ...state.internal.model };
    const certifications = model.certifications ?? [];

    const handleActionBtnClick = (certificationId: string) => {
        setActionBtnStatus({
            ...actionBtnStatus,
            [certificationId]: !actionBtnStatus[certificationId],
        });
    };

    const handleDownloadPdf = (pdfUrl: string, fileName: string) => {
        if (!pdfUrl) return;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = fileName || 'certificate.pdf';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div>
            <div className="certifications-list achievements-list">
                <div className="certifications-block-title achievements-block-title">
                    <div className="row g-2">
                        <div className="col">
                            {model.isEditable && <div className="title">My Certifications</div>}
                            {!model.isEditable && (
                                <div className="title">
                                    Certifications of{' '}
                                    <span>
                                        {`${model.firstName}`} {model.lastName ? `${model.lastName}` : ''}
                                    </span>
                                </div>
                            )}
                        </div>
                        {model.isEditable && !isSchoolAdmin() && (
                            <div className="col-auto">
                                <a
                                    role="button"
                                    onClick={() => navigate(`/alumni/${model.id}/certifications`)}
                                    className="btn-add-section">
                                    <i></i> <span>ADD</span>
                                </a>
                            </div>
                        )}
                    </div>
                </div>

                {certifications.length === 0 ? (
                    <div className="empty-state">
                        <p>No certifications added yet</p>
                    </div>
                ) : (
                    certifications.map((cert: any) => (
                        <div key={cert.id} className="certifications-block achievements-block">
                            <div className="certifications-icon-block achievements-icon-block">
                                <div className="icon icon-certificate"></div>
                                <div className="certifications-icon-title achievements-icon-title">
                                    <div className="certifications-title achievements-title">{cert.issuingOrganization}</div>
                                    <div className="certifications-year achievements-year">
                                        {cert.issueMonth} {cert.issueYear}
                                        {cert.expiryDate && (
                                            <span className={cert.isExpired ? 'expired' : ''}>
                                                {' '}- {cert.expiryMonth} {cert.expiryYear}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="certifications-block-detail achievements-block-detail">
                                <div className="row g-3 align-items-center">
                                    <div className="col-md">
                                        <div className="row g-3">
                                            <div className="col-md">
                                                <h3>{cert.title}</h3>
                                                {cert.credentialId && <p className="credential-id">ID: {cert.credentialId}</p>}
                                                {cert.description && <p className="description">{cert.description}</p>}
                                                {cert.credentialUrl && (
                                                    <a href={cert.credentialUrl} target="_blank" rel="noopener noreferrer">
                                                        {cert.credentialUrl}
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-auto">
                                        <div className="cert-actions d-flex gap-2 flex-column">
                                            {cert.pdfStorageUrl && (
                                                <button
                                                    className="btn btn-sm btn-outline-primary w-100 text-center"
                                                    onClick={() => handleDownloadPdf(cert.pdfStorageUrl, cert.pdfFileName)}
                                                    title="Download PDF">
                                                    <i className="icon-pdf"></i> PDF
                                                </button>
                                            )}

                                            {model.isEditable && !isSchoolAdmin() && (
                                                <div className={`edit_section ${actionBtnStatus[cert.id] ? 'open' : ''}`}>
                                                    <button
                                                        className="edit_section_toggle"
                                                        onClick={() => handleActionBtnClick(cert.id)}></button>
                                                    <div className="edit_section_inner">
                                                        <a
                                                            href={`/alumni/${model.id}/certifications`}
                                                            className="edit_link">
                                                            Edit
                                                        </a>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}

            </div>
        </div>
    );
};

export default ProfileCertifications;
